import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
} from "@mui/material";
import theme from "../../theme";

export const StyledWrapper = styled(Box)(({ isPad }) => ({
  paddingLeft: isPad ? "40px" : "",
}));
export const StyledNavbar = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "flex-end",
}));
export const StyledLogo = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  padding: "20px 0px",
  backgroundColor: theme.palette.custom.white,
}));

export const StyledList = styled(List)(({theme,menutype,isAdmin}) => ({
  marginLeft: "40px",
  padding: "0px",
  marginTop: menutype === "top" ? "50px" : isAdmin ? "185px" : "275px",
  marginBottom: "27px",
  [theme.breakpoints.down("sm")]: {
    marginTop: menutype === "top" ? "50px" : "40px",
    marginBottom: "17px",
  },
  

}));
export const StyledDrawer = styled(Drawer)(() => ({
  width: "300px",
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  "& .MuiDrawer-paper": {
    backgroundColor: theme.palette.custom.sidebarBg,
    width: "300px",
    height: "100%",
    color: theme.palette.custom.white,
    display: "flex",
    borderRight: "none",
    flexDirection: "column",
    justifyContent: "space-between",
    overflowY: "auto",
    overflowX: "hidden",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
      width: 0,
      height: 0,
    },
  },
}));
export const StyledListItemText = styled(ListItemText)(({ theme}) => ({
  "& .MuiTypography-root": {
    fontSize: theme.typography.small.fontSize,
    fontWeight: 400,
  },
  marginLeft: "2px",
}));
export const StyledListItemButtonBox = styled(ListItemButton)(
  ({ theme, isselecteditem }) => ({
    color: isselecteditem
      ? theme.palette.custom.blackColor
      : theme.palette.custom.white,
    backgroundColor: isselecteditem
      ? theme.palette.custom.white
      : "transparent",
    borderLeft: isselecteditem ? "9px solid #FF8500" : "none",
    height: "40px",
    display: "flex",
    alignItems: "center",
    fontWeight: theme.typography.fontWeight.semiBold,
    width: "235px",
    "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected.Mui-focusVisible": {
      color: theme.palette.custom.blackColor,
      backgroundColor: `${theme.palette.custom.white} !important`,
    },
    "&:hover": {
      background: isselecteditem ? "white" : "inherit",
    },
    ".MuiTypography-root": {
      fontSize: isselecteditem
        ? `${theme.typography.medium.fontSize} !important`
        : theme.typography.small.fontSize,
      fontWeight: theme.typography.fontWeight.semiBold,
    },
  })
);
export const StyledListItemIcon = styled(ListItemIcon)(
  ({ theme, isselecteditem }) => ({
    color: isselecteditem
      ? theme.palette.custom.blackColor
      : theme.palette.custom.white,

    fontSize: theme.typography.extraSmall.regular,
    paddingLeft: isselecteditem ? "" : "9px",
    minWidth: isselecteditem ? "30px" : "40px",
  })
);
export const StyledBoxLogOut = styled(Box)(() => ({
  paddingRight: "20px",
  marginBottom: "32px",
  marginLeft: "40px",
  width: "235px",
}));
